import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { Text } from "../../../foundations/typography/Text";
import { InputButton } from "../../../internal/InputButton";
import { PickerItem, TriggerProps } from "../types";

export function SelectTrigger<T extends PickerItem>(props: TriggerProps<T>) {
  const { t } = useTranslation();

  const hasSelectedItems = props.selectedItems.length > 0;

  return (
    <InputButton rightIcon="expand_more">
      <Text
        style="input/text-field"
        color={hasSelectedItems ? "text-base" : "text-placeholder"}
        className={styles.truncate}
      >
        {hasSelectedItems
          ? props.selectedItems.map((item) => item.name).join(", ")
          : t("Please select")}
      </Text>
    </InputButton>
  );
}

const styles = {
  truncate: css({
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
};
